import LocalizedStrings from 'react-localization';

const strings = new LocalizedStrings({
    en:{
      title:'CAR BOOKING SERVICE',
      bookCarOnline:'BOOK CAR ONLINE',
      phone:'Phone',
      enterPhone:'Enter your phone number',
      name:'Name',
      enterName: 'Enter your name',
      from: 'From',
      enterFrom: 'Enter the start point',
      to: 'To',
      enterTo: 'Enter the end point',
      time: 'Time',
      date: 'Date',
      enterTime: 'Enter time to start',
      next: 'NEXT',
      dowloadTitle: 'DOWNLOAD APP FOR MOBILE',
      selectCar: 'SELECT CAR',
      price: 'Price',
      back: 'BACK',
      typeOfService: 'Type of service',
      booking: 'BOOKING',
      confirmInfomation: 'CONFIRM INFORMATION',
      bookingCarSuccess: 'BOOKING CAR SUCCESS',
      makeNewRequest: 'CREATE NEW BOOKING',
      pleaseInputYourPhone: 'Please input your phone',
      pleaseInputYourName: 'Please input your name',
      pleaseInputStartPoint: 'Please input start point',
      pleaseInputEndPoint: 'Please input end point',
      confirmTimeTxt: 'Ok',
      cancelTimeTxt: 'Cancel',
    },
    vi: {
      title:'ỨNG DỤNG ĐẶT XE DỊCH VỤ ĐƯỜNG DÀI',
      bookCarOnline:'ĐẶT XE TRỰC TUYẾN',
      phone:'Số điện thoại',
      enterPhone:'Nhập số điện thoại',
      name:'Họ tên',
      enterName: 'Nhập họ tên',
      from: 'Điểm đi',
      enterFrom: 'Nhập điểm đi',
      to: 'Điểm đến',
      enterTo: 'Nhập điểm đến',
      time: 'Giờ đi',
      date: 'Ngày đi',
      enterTime: 'Nhập thời gian',
      next: 'TIẾP TỤC',
      dowloadTitle: 'TẢI ỨNG DỤNG CHO ĐIỆN THOẠI',
      selectCar: 'CHỌN LOẠI XE',
      price: 'Giá tiền',
      back: 'QUAY LẠI',
      typeOfService: 'Loại xe',
      booking: 'ĐẶT XE',
      confirmInfomation: 'XÁC NHẬN THÔNG TIN',
      bookingCarSuccess: 'ĐẶT XE THÀNH CÔNG',
      makeNewRequest: 'ĐẶT CHUYẾN KHÁC',
      pleaseInputYourPhone: 'Nhập thiếu số điện thoại',
      pleaseInputYourName: 'Nhập thiếu tên',
      pleaseInputStartPoint: 'Nhập thiếu điểm đi',
      pleaseInputEndPoint: 'Nhập thiếu điểm đến',
      confirmTimeTxt: 'Đồng ý',
      cancelTimeTxt: 'Huỷ',
    }
   });
export default strings;


// WEBPACK FOOTER //
// ./src/utils/strings.js